module.exports = __webpack_public_path__ + "img/img_05.fcfc98c7.png";